var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurlLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.07 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a16a38;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Curl Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colour_-_Dark",
    "data-name": "Colour - Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "On",
    className: "cls-1",
    d: "M79.77,2.77c-3,3.33-9.29,6.51-19,7.21-14.32,1-27.11-5.07-43.2-3.9C9.15,6.7,5,9,3.11,10.15c-1.45.91-4-.11-2.82-1.4C3.63,5.08,11.4,1,23.17.14,38.29-1,53.43,4.89,67.91,3.83a21.78,21.78,0,0,0,9-2.46C78.56.44,80.9,1.48,79.77,2.77Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlLeft);
export default __webpack_public_path__ + "static/media/curl_left.375b61ae6e848af07c32c341d373f4fc.svg";
export { ForwardRef as ReactComponent };